
<app-base-template (modal)="openModal(content)" (searchmodal) = "searchModal()" (dataExportToExcel)="exportToExcel()"(tabledata)="getTableData()" [displayData]="displayData" [nextOffset]="nextOffset"
                   [previousOffset]="previousOffset" (offset)="getData($event)"
                   (pageSize)="onPageSizeChange($event)" [pageNo]="page_no" [showSearch]="showSearch" [isExportDisable]="isExportDisable"[showExportBtn]="showExportBtn" [totalPage]="totalPage"[dataLoaded]="dataLoaded" [isExportDisable]="isExportDisable"></app-base-template>
<ng-template #content let-c="close" let-d="dismiss">
  <div class="modal-header modalTitle">
    <div class="modal-title">Add Check List</div>

  </div>
  <div class="modal-body">
    <div class="none" [ngClass]="{'inputError':isError}">{{errorMessage}}</div>
    <div class="form-group">
      <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="ticketSelected"
              (change)="onTicketChange($event.target.selectedIndex)">
        <option *ngFor="let ticket of ttypes" [value]="ticket.id">{{ticket.name}}</option>
      </select>
    </div>

    <div class="row mar-lft-rgt-0" [hidden]="!isCategory">
      <div class="col-md-12 pad-15 category">
        <div class="height-40" [hidden]="categoryLoaded">
          <img class="loading-gif-42" src="../../../assets/img/loader-42px.gif">
        </div>
        <select class="custom-select  tcktyp" *ngFor="let ticket of ticketTypes;"
                (change)="onCategoryChange(ticket,$event.target.value)" id="ticket_{{ticket.id}}"
                [hidden]="!categoryLoaded">
          <option *ngFor="let option of ticket.options" [value]="option|json">{{option.title}}</option>
        </select>
      </div>
    </div>

    <div class="form-group" [hidden]="!isStatus">
      <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="ststusSelected"
              (change)="onStatusChange($event.target.selectedIndex)">
        <option *ngFor="let status of ticket_status" [value]="status.id">{{status.status}}</option>
      </select>
    </div>

    <div class="form-group">
      <textarea class="form-control radius-0 font-13" [(ngModel)]="description" placeholder="Description" required></textarea>
    </div>
    <div class="form-group">
      <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="typeSelected"
              (change)="onTypeChange($event.target.selectedIndex)">
        <option *ngFor="let type of types" [value]="type.id">{{type.name}}</option>
      </select>
    </div>
    <div class="form-group" [hidden]="!isDropdown">
      <input type="text" class="form-control radius-0 font-13" [(ngModel)]="dropdown" placeholder="Comma separated dropdown value">
    </div>
  </div>
  <div class="modal-footer pad-8">
    <button type="button" class="btn btn-success radius-0" (click)="save()">Save</button>
    <button type="button" class="btn btn-danger radius-0" (click)="c()">Cancel</button>
  </div>

</ng-template>



<ng-template #content1 let-c="close" let-d="dismiss">
  <div class="modal-header modalTitle">
    <div class="modal-title">Update Check List</div>

  </div>
  <div class="modal-body">
      
    
    <div class="none" [ngClass]="{'inputError':isError}">{{errorMessage}}</div>
    <div class="form-group" >
        <input type="text" class="form-control radius-0 font-13" [(ngModel)]="typeName" readonly>
      </div>
      <div class="form-group" >
          <input type="text" class="form-control radius-0 font-13" [(ngModel)]="catName" readonly>
        </div>
        <div class="form-group" >
            <input type="text" class="form-control radius-0 font-13" [(ngModel)]="statusName" readonly>
          </div>
  

    <div class="form-group">
      <textarea class="form-control radius-0 font-13" [(ngModel)]="description" placeholder="Description" required></textarea>
    </div>
    <div class="form-group">
      <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="typeSelected"
              (change)="onTypeChange($event.target.selectedIndex)">
        <option *ngFor="let type of types" [value]="type.id">{{type.name}}</option>
      </select>
    </div>
    <div class="form-group" [hidden]="!isDropdown">
      <input type="text" class="form-control radius-0 font-13" [(ngModel)]="dropdown" placeholder="Comma separated dropdown value">
    </div>
  </div>
  <div class="modal-footer pad-8">
    <button type="button" class="btn btn-success radius-0" (click)="update()">Update</button>
    <button type="button" class="btn btn-danger radius-0" (click)="c()">Cancel</button>
  </div>

</ng-template>


<ng-template #scarch_content let-c="close" let-d="dismiss">
  <div class="modal-header modalTitle">
    <div class="modal-title">Search</div>

  </div>
  <div class="modal-body">

      <div class="form-group mar_top">
          <input type="text" class="form-control radius-0 font-13" placeholder=" Enter Checklist Item"
                 [(ngModel)]="checkList"
                 matInput [formControl]="searchData"[matAutocomplete]="auto"
                >
          <mat-autocomplete #auto="matAutocomplete" (optionSelected)="getDetails()">
              <mat-option *ngIf="isLoading" class="is-loading">
                  <mat-spinner diameter="50"></mat-spinner>
              </mat-option>
              <ng-container *ngIf="!isLoading">
                  <mat-option *ngFor="let item of items" [value]="item.description">
                    {{ item.description }} 
                  </mat-option>
              </ng-container>
          </mat-autocomplete>
      </div>
  </div>
  <div class="modal-footer pad-8">
          <button type="button" class="btn btn-success float-right radius-0" (click)="search()">search</button>
          <button type="button" class="btn btn-danger radius-0" (click)="c()">Cancel</button>
  </div>

  </ng-template>
<notifier-container></notifier-container>
